module.exports = __webpack_public_path__ + "static/media/HomeStoryImage7.834e03ba.jpg";